import { render, staticRenderFns } from "./SimpleData.vue?vue&type=template&id=71ac592a&"
import script from "./SimpleData.vue?vue&type=script&lang=js&"
export * from "./SimpleData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports